export const ROLE_PRIORITIES: any = {
  1: 100,
  100: 80,
  101: 60,
};
